module.exports = __webpack_public_path__ + "img/deviceBgImg.4910b315.png";